module.exports = __webpack_public_path__ + "img/05010004.cdf83161.jpg";